import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "show-in-print" }
const _hoisted_2 = { class: "d-flex align-items-center mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-produkte_formulare",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 px-0 hide-in-print" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-produkte_formulare",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_8 = { class: "row hide-in-print" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "col-12 col-md-3" }
const _hoisted_11 = { class: "col-12 col-md-2" }
const _hoisted_12 = { class: "col-12 col-md-2" }
const _hoisted_13 = { class: "col-12 col-md-3" }
const _hoisted_14 = { class: "col-12 col-md-2" }
const _hoisted_15 = { class: "col-12 d-flex justify-content-end hide-in-print" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12 d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_back = _resolveComponent("link-back")!
  const _component_tabs_ticket_type = _resolveComponent("tabs-ticket-type")!
  const _component_control_search = _resolveComponent("control-search")!
  const _component_control_date = _resolveComponent("control-date")!
  const _component_button_search = _resolveComponent("button-search")!
  const _component_button_reset = _resolveComponent("button-reset")!
  const _component_button_print = _resolveComponent("button-print")!
  const _component_result_list_tickets = _resolveComponent("result-list-tickets")!
  const _component_loading_container = _resolveComponent("loading-container")!
  const _component_result_paging = _resolveComponent("result-paging")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.reservations.title')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, [
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('views.reservations.title')), 1)
        ])
      ]),
      _createVNode(_component_link_back, {
        to: "/",
        i18nMessage: "common.backToDashboard",
        class: "mt-2 hide-in-print"
      }),
      _createVNode(_component_loading_container, { state: _ctx.state }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_tabs_ticket_type, {
                tabs: _ctx.getTabsTicketTypeOptions(),
                activeTab: _ctx.searchType,
                onChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSearchType($event)))
              }, null, 8, ["tabs", "activeTab"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_control_search, {
                i18nLabel: "views.reservations.search",
                modelValue: _ctx.searchTerm,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.doNewSearch()), ["enter"]))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_control_date, {
                i18nLabel: "views.reservations.searchFrom",
                modelValue: _ctx.searchFrom,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFrom) = $event)),
                  _cache[4] || (_cache[4] = ($event: any) => (_ctx.doNewSearch()))
                ]
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_control_date, {
                i18nLabel: "views.reservations.searchUntil",
                modelValue: _ctx.searchUntil,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchUntil) = $event)),
                  _cache[6] || (_cache[6] = ($event: any) => (_ctx.doNewSearch()))
                ]
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_button_search, {
                onClicked: _cache[7] || (_cache[7] = ($event: any) => (_ctx.doNewSearch())),
                labelHidden: true
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.isResettable())
                ? (_openBlock(), _createBlock(_component_button_reset, {
                    key: 0,
                    onClicked: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resetTermAndDate())),
                    labelHidden: true,
                    class: "m-0 p-0 btn-to-danger-link-filter"
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_button_print, { i18nMessage: "common.printActual" })
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_loading_container, {
              state: _ctx.searchState,
              class: "px-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_result_list_tickets, {
                  tickets: _ctx.tickets,
                  sortOptions: _ctx.sortOptions,
                  searchType: _ctx.searchType,
                  onSortChanged: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setSortBy($event)))
                }, null, 8, ["tickets", "sortOptions", "searchType"])
              ]),
              _: 1
            }, 8, ["state"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              (_ctx.maxPage() > 1)
                ? (_openBlock(), _createBlock(_component_result_paging, {
                    key: 0,
                    active: _ctx.activePage(),
                    max: _ctx.maxPage(),
                    onChanged: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setActivePage($event)))
                  }, null, 8, ["active", "max"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["state"])
    ])
  ], 64))
}